import { render, staticRenderFns } from "./addGr.vue?vue&type=template&id=60aebb92&"
import script from "./addGr.vue?vue&type=script&lang=js&"
export * from "./addGr.vue?vue&type=script&lang=js&"
import style0 from "./addGr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports